import React from 'react';
import PropTypes from 'prop-types';
import { Marker, OverlayView } from '@react-google-maps/api';

const getPixelPositionOffset = (width) => ({
  x: -(width / 2),
  y: 0,
});

const MarkerWithLabel = ({ label, labelStyle, ...props }) => {
  return (
    <Marker {...props}>
      <OverlayView
        key="mwl"
        position={props.position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={getPixelPositionOffset}
      >
        <div style={labelStyle}>{label}</div>
      </OverlayView>
    </Marker>
  );
};

// Declared only to satisfy react/prop-types; deliberately permissive so this adds no
// runtime warning that master does not already emit. Nothing is `isRequired` and the
// coordinates accept strings: call sites pass API payloads straight through
// (LocationsList/index.jsx:387 forwards `_location.center` unvalidated), and this PR
// must not change observable behaviour anywhere.
MarkerWithLabel.propTypes = {
  label: PropTypes.node,
  labelStyle: PropTypes.object,
  position: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
};

export default MarkerWithLabel;
